import GoBackButton from '@/common/components/GoBackButton'
import { MaintenanceForwardingsDirectiveFormProps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import { useParams } from 'react-router-dom'

const CreateForwardingDirectiveData = ({ directiveDetails }: MaintenanceForwardingsDirectiveFormProps) => {
  const { id: workflowId } = useParams()

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <GoBackButton
          fallback={`/maintenance-workflows/${workflowId}/forwardings/create`}
          searchLastRouteFromFallback
        />

        <p className="text-lg font-bold">{directiveDetails.name}</p>
      </div>

      <div>
        <p className="text-sm text-white-400 whitespace-pre-wrap">{directiveDetails.description}</p>
      </div>
    </div>
  )
}

export default CreateForwardingDirectiveData
